import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Shield, FileText, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { api } from '../utils/api';

export const LegalPage = ({ type }) => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLegal = async () => {
      setLoading(true);
      try {
        const id = type === 'privacy' ? 'privacy_policy' : 'terms_of_use';
        const res = await api.legal.getById(id);
        setContent(res.data.content);
      } catch (error) {
        console.error('Error fetching legal content:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchLegal();
    window.scrollTo(0, 0);
  }, [type]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="w-12 h-12 border border-white/10 rounded-full flex items-center justify-center animate-spin">
          <div className="w-2 h-2 rounded-full bg-[#C6FF00]"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white selection:bg-[#C6FF00] selection:text-black">
      <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none"></div>
      <div className="absolute inset-0 mesh-gradient opacity-20 pointer-events-none"></div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Link
            to="/"
            className="inline-flex items-center space-x-3 text-white/30 hover:text-[#C6FF00] transition-colors mb-12 text-[10px] font-black uppercase tracking-[0.4em]"
          >
            <ArrowLeft size={12} />
            <span>Inicio</span>
          </Link>

          <div className="flex items-center gap-6 mb-12">
            <div className="w-16 h-16 rounded-2xl bg-[#C6FF00]/10 border border-[#C6FF00]/20 flex items-center justify-center text-[#C6FF00]">
              {type === 'privacy' ? <Shield size={32} /> : <FileText size={32} />}
            </div>
            <div>
              <span className="text-[#C6FF00] font-black uppercase tracking-[0.3em] text-[10px] block mb-2">Protocolos Legales</span>
              <h1 className="text-5xl sm:text-7xl font-black tracking-tighter italic uppercase">
                {type === 'privacy' ? 'Privacidad' : 'Términos'}
              </h1>
            </div>
          </div>

          <div className="p-12 sm:p-20 rounded-[4rem] bg-white/[0.02] backdrop-blur-3xl border border-white/5 shadow-2xl">
            <div 
              className="prose prose-invert prose-lg max-w-none quill-content"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>

          <style>{`
            .quill-content { color: rgba(255, 255, 255, 0.5); font-weight: 500; font-size: 1.125rem; line-height: 1.8; }
            .quill-content h1, .quill-content h2, .quill-content h3 { 
              color: white; 
              font-weight: 900; 
              margin-top: 4rem; 
              margin-bottom: 1.5rem; 
              letter-spacing: -0.05em; 
              text-transform: uppercase;
              font-style: italic;
            }
            .quill-content h1 { font-size: 3rem; }
            .quill-content h2 { font-size: 2rem; }
            .quill-content p { margin-bottom: 2rem; }
            .quill-content ul { list-style-type: none; margin-bottom: 3rem; }
            .quill-content ul li { position: relative; padding-left: 2rem; margin-bottom: 1rem; color: rgba(255,255,255,0.4); }
            .quill-content ul li::before { 
              content: ''; 
              position: absolute; 
              left: 0; 
              top: 0.7em; 
              width: 0.5rem; 
              height: 1px; 
              background: #C6FF00; 
            }
            .quill-content strong { color: white; font-weight: 800; }
          `}</style>

          <footer className="mt-20 text-center">
            <p className="text-white/20 text-[10px] font-black uppercase tracking-[0.4em]">
              BUILD BRAINS LEGAL UNIT / {new Date().getFullYear()}
            </p>
          </footer>
        </motion.div>
      </div>
    </div>
  );
};
